export default "__VITE_ASSET__cIyS8aOO__"